import { classNamesOrEmpty } from "../../style/common";

export function CardVariantImageDarkenOverlay(props: { className?: string | undefined }) {
    return (
        <div className={`rounded-xl absolute top-0 bottom-0 left-0 right-0 bg-black opacity-[.25] ${classNamesOrEmpty(props.className)}`}>

        </div>
    )
}